import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home, ArrowRight } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center px-4">
        <div className="text-8xl font-display font-bold text-primary/15 mb-4">404</div>
        <h1 className="text-3xl font-display font-bold text-foreground mb-4">Page Not Found</h1>
        <p className="text-muted-foreground mb-8 max-w-sm">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Button asChild className="bg-primary hover:bg-primary-light text-primary-foreground shadow-primary-token transition-fast">
          <Link to="/">
            <Home className="mr-2 w-4 h-4" />
            Back to Home
          </Link>
        </Button>
      </div>
    </div>
  );
}
